import { Link } from "react-router-dom";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqSection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-[0.85fr_1.15fr] gap-10 lg:gap-14">
        <div>
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-bold">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-black text-foreground-950 font-heading leading-snug">
            第一次来，先看看这些
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            关于内容来源、更新节奏和参与方式，这里整理了大家最常问的几个问题。还有疑问可以随时通过投稿页面联系我们。
          </p>
          <Link
            to="/submit"
            className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-bold whitespace-nowrap hover:bg-foreground-800 transition-colors"
          >
            <i className="ri-mail-send-line"></i>
            还有问题，联系我们
          </Link>
        </div>

        <FaqAccordion items={faqs} />
      </div>
    </section>
  );
}